import styles from './ToastNotification.module.css';

const ToastNotification = ({
  message = '',
  visible = false,
  className = '',
  variant = 'error',
}) => {
  if (!message) {
    return null;
  }

  const variantClassName =
    variant === 'success'
      ? styles.toastSuccess
      : variant === 'warning'
        ? styles.toastWarning
        : variant === 'neutral'
          ? styles.toastNeutral
        : '';

  const rootClassName = [
    styles.toast,
    variantClassName,
    visible ? styles.toastVisible : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClassName} role="status" aria-live="polite">
      <span className={styles.toastMessage}>{message}</span>
    </div>
  );
};

export default ToastNotification;
